import React from 'react';
import { cn } from '@agnes/ui';

/**
 * Card de seção com destaque (elevação) padrão do produto.
 * Elevação via tokens temáticos (sombra + fundo trocam com data-theme), então
 * funciona igual em dark e light. Passe `className` para ajustar padding/layout.
 */
export function SectionCard({
  className,
  children,
  ...rest
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'rounded-xl border border-agnes-border bg-agnes-bg-default p-4 shadow-agnes-card',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}

/**
 * Título de card/seção com acento roxo à esquerda — destaque de marca pontual,
 * theme-safe (a barra usa a cor da marca; o texto usa token temático).
 */
export function CardTitle({ className, children, ...rest }: React.HTMLAttributes<HTMLSpanElement>) {
  return (
    <span
      className={cn('flex items-center gap-2 font-semibold text-agnes-text-primary', className)}
      {...rest}
    >
      <span className="h-4 w-1 shrink-0 rounded-full bg-agnes-primary" aria-hidden />
      {children}
    </span>
  );
}
